export default __webpack_public_path__ + "static/media/DocumentPreview.9be5f1b5.svg";